module.exports = __webpack_public_path__ + "static/img/xsyj.67c1b68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homepage/xsyj.png
// module id = AgLM
// module chunks = 1